import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AnsoegningService } from 'src/app/api/services';

@Component({
  selector: 'bom-kvittering-redirect',
  templateUrl: './kvittering-redirect.component.html',
  styleUrls: ['./kvittering-redirect.component.scss'],
})
export class KvitteringRedirectComponent implements OnInit {
  constructor(
    private ansoegningService: AnsoegningService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.pipe(take(1)).subscribe(params => {
      this.ansoegningService.getKvitteringLink(params.ansoegningId).subscribe({
        next: link => {
          this.router.navigate([link], { replaceUrl: true });
        },
      });
    });
  }
}
